export default {
    FORM_UTILS_VALIDATE_FORM_FIELD: 'FORM_UTILS_VALIDATE_FORM_FIELD',
    FORM_UTILS_ADD_NEW_FORM_ENTRY: 'FORM_UTILS_ADD_NEW_FORM_ENTRY',
    FORM_UTILS_BUILD_FORM_FROM_OBJECT: 'FORM_UTILS_BUILD_FORM_FROM_OBJECT',
    FORM_UTILS_SET_FIELD_FORM_VALUE: 'FORM_UTILS_SET_FIELD_FORM_VALUE',
    FORM_UTILS_SET_FIELD_FORM_PROPS: 'FORM_UTILS_SET_FIELD_FORM_PROPS',
    FORM_UTILS_SET_FIELD_FORM_RULES: 'FORM_UTILS_SET_FIELD_FORM_RULES',
    FORM_UTILS_MARK_FORM_FIELD_ERROR_CODE_412: 'FORM_UTILS_MARK_FORM_FIELD_ERROR_CODE_412'
}